var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component != null)?_c('v-container',{staticClass:"subsection"},[_c('SubSectionFactory',{attrs:{"component":_vm.component,"variant_color":_vm.variant_color}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }